// only use for compose pure function
export const pipe = (...funcs) => {
  return (value) => {
    const copiedFuncs = funcs.slice();

    while (copiedFuncs.length > 0) {
      const func = copiedFuncs.shift();
      if (func) {
        value = func(value);
      }
    }

    return value;
  };
};
